import ApiService from "@/services/api.service";

const state = {
    loading: false,
    previewResult: null,
    error: null,
    successMessage: null,
};

const getters = {
    loading: (state) => state.loading,
    previewResult: (state) => state.previewResult,
    error: (state) => state.error,
    successMessage: (state) => state.successMessage,
};

const mutations = {
    setLoading(state, val) {
        state.loading = val;
    },
    setPreviewResult(state, val) {
        state.previewResult = val;
    },
    setError(state, val) {
        state.error = val;
    },
    setSuccessMessage(state, val) {
        state.successMessage = val;
    },
    reset(state) {
        state.loading = false;
        state.previewResult = null;
        state.error = null;
        state.successMessage = null;
    },
};

const actions = {
    PREVIEW_ZIP({ commit }, formData) {
        commit("setLoading", true);
        commit("setError", null);
        commit("setPreviewResult", null);
        return new Promise((resolve, reject) => {
            ApiService.postFormData("PstImport/preview", formData)
                .then(({ data }) => {
                    commit("setPreviewResult", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    const msg =
                        response?.data?.title ||
                        response?.data ||
                        "Errore durante la preview del file ZIP.";
                    commit("setError", msg);
                    reject(msg);
                })
                .finally(() => commit("setLoading", false));
        });
    },

    UPLOAD_ZIP({ commit }, formData) {
        commit("setLoading", true);
        commit("setError", null);
        commit("setSuccessMessage", null);
        return new Promise((resolve, reject) => {
            ApiService.postFormData("PstImport/upload", formData)
                .then(({ data }) => {
                    commit(
                        "setSuccessMessage",
                        data?.messaggio ||
                            "Importazione avviata. Riceverai una notifica via mail al termine."
                    );
                    resolve(data);
                })
                .catch(({ response }) => {
                    const msg =
                        response?.data?.title ||
                        response?.data ||
                        "Errore durante il caricamento del file ZIP.";
                    commit("setError", msg);
                    reject(msg);
                })
                .finally(() => commit("setLoading", false));
        });
    },

    IMPORT_FROM_PATH({ commit }, payload) {
        commit("setLoading", true);
        commit("setError", null);
        commit("setSuccessMessage", null);
        return new Promise((resolve, reject) => {
            ApiService.post("PstImport/from-path", payload)
                .then(({ data }) => {
                    commit(
                        "setSuccessMessage",
                        data?.messaggio ||
                            "Importazione avviata. Riceverai una notifica via mail al termine."
                    );
                    resolve(data);
                })
                .catch(({ response }) => {
                    const msg =
                        response?.data?.title ||
                        response?.data ||
                        "Errore durante l'avvio dell'importazione da percorso.";
                    commit("setError", msg);
                    reject(msg);
                })
                .finally(() => commit("setLoading", false));
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
